import React from 'react';
import { GoArrowSwitch } from 'react-icons/go';

const SwitchButton = ({ onClick, switchText }) => {
    return (
        <button
            className="absolute flex flex-row justify-center items-center xs:gap-1 gap-2 top-1 right-1 bg-white border hover:border-gray-500 py-2 px-4 rounded text-xs text-gray-800 lg:w-36 xs:min-w-28 min-w-24"
            onClick={onClick}
        >
            <GoArrowSwitch />
            LLM: {switchText}
        </button>
    )
}

export default SwitchButton;